/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Row, Col } from "react-awesome-styled-grid";
import { useNavigate } from "react-router-dom";
import { FlexContainer, Heading, Message, Spacer } from "@nordcloud/gnui";
import { InfoCard } from "~/components";
import { ReactComponent as BrowserIcon } from "../../../assets/images/browser.svg";
import { ReactComponent as PlusIcon } from "../../../assets/images/plus.svg";

type Props = {
  applicationId?: string | null;
  clearHandler: () => void;
};

export function Summary({ applicationId, clearHandler }: Props) {
  const navigate = useNavigate();
  return (
    <Row justify="center">
      <Col sm={8} md={6}>
        <Message status="success" image="success">
          Application has been added
        </Message>
        <Spacer height="1.5rem" />
        <FlexContainer justifyContent="space-between">
          <InfoCard
            align="center"
            onClick={() => {
              navigate(`/applications/${applicationId}`);
            }}
          >
            <BrowserIcon />
            <Heading marginTop="1rem" level={4}>
              Application Details
            </Heading>
          </InfoCard>
          <InfoCard
            align="center"
            onClick={() => {
              navigate(`/applications`);
            }}
          >
            <BrowserIcon />
            <Heading marginTop="1rem" level={4}>
              Applications List
            </Heading>
          </InfoCard>
          <InfoCard align="center" onClick={() => clearHandler()}>
            <PlusIcon />
            <Heading marginTop="1rem" level={4}>
              Add Another Application
            </Heading>
          </InfoCard>
        </FlexContainer>
      </Col>
    </Row>
  );
}
